document.addEventListener("DOMContentLoaded", function () {
    const menu = document.querySelector(".filters-vp__content");
    const scrollLeft = document.querySelector(".scroll-left");

    scrollLeft.addEventListener("click", function () {
        menu.scrollBy({ left: 150, behavior: 'smooth' });
    });

    function updateArrows() {
        if (menu.scrollWidth <= menu.clientWidth) {
            scrollLeft.style.display = "none";
        } else {
            scrollLeft.style.display = "block";
        }
    }

    window.addEventListener("resize", updateArrows);
    updateArrows();
});
